import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#660099",
      light: "#993FCB",
      dark: "#33006A",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#FFCC33",
      light: "#FFFF69",
      dark: "#C89B00",
      contrastText: "#000",
    },
    info: {
      main: "#FFCC33",
      light: "#FFFF69",
      dark: "#C89B00",
      contrastText: "#000",
    },
    success: {
      main: "#660099",
      light: "#993FCB",
      dark: "#33006A",
      contrastText: "#FFF",
    },
  },
});

export default theme;
